/**
 * Mark every supplied chat room as "seen" up to its current latest id.
 *
 * Thin wrapper around `markChatRoomSeen` from
 * `@/hooks/use-boards-chat-unread` that fans the call out across a list
 * of rooms. Used by:
 *
 *   - The desktop `BoardDirectory` "Mark as read" action that clears
 *     every red dot on the My Boards tab in one click.
 *   - The mobile `MobileChatBoardList` (footer Chat tab) which mirrors
 *     the desktop list and needs the same one-shot action.
 *
 * Skips rooms with no known `latestId` (e.g. the API hasn't reported a
 * message id for that room yet — there's literally nothing to mark
 * read). `latestIds` is the shape returned by `useBoardsChatUnread`'s
 * `latestIds` field — a `Record<roomId, latestMessageId>`.
 */

import { markChatRoomSeen } from '@/hooks/use-boards-chat-unread';

export function markRoomsSeen(
  rooms: string[],
  address: string,
  latestIds: Record<string, number>,
): void {
  if (!address) return;
  for (const room of rooms) {
    const canonical = room.toLowerCase();
    const id = latestIds[canonical] ?? 0;
    if (id <= 0) continue;
    markChatRoomSeen(id, address, canonical);
  }
}
